import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AttentionLabsLanding from './pages/AttentionLabsLanding';
import Alt1Landing from './pages/Alt1Landing';
import Alt2Landing from './pages/Alt2Landing';
import Portfolio from './pages/Portfolio';
import CaseStudiesListing from './pages/CaseStudiesListing';
import CaseStudies from './pages/CaseStudies';
import CaseStudyParallax from './pages/CaseStudyParallax';
import Methodology from './pages/Methodology';
import Intelligence from './pages/Intelligence';
import AttentionEngineering from './pages/AttentionEngineering';
import ContentStrategy from './pages/ContentStrategy';
import MediaMoats from './pages/MediaMoats';
import Contact from './pages/Contact';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AttentionLabsLanding />} />
          <Route path="/alt1" element={<Alt1Landing />} />
          <Route path="/alt2" element={<Alt2Landing />} />
          <Route path="/methodology" element={<Methodology />} />
          <Route path="/intelligence" element={<Intelligence />} />
          <Route path="/intelligence/attention-engineering" element={<AttentionEngineering />} />
          <Route path="/intelligence/content-strategy" element={<ContentStrategy />} />
          <Route path="/intelligence/media-moats" element={<MediaMoats />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/casestudies" element={<CaseStudiesListing />} />
          <Route path="/case-studies/:slug" element={<CaseStudyParallax />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
